import { gql } from '@apollo/client'

export const GET_USER_BLOCKCHAIN_BALANCES = gql(`
  query getUserBlockchainBalances {
    getUserBlockchainBalances {
      walletAddress
      nativeBalance
      tokenBalance
      tokenDeposited
      chainIdentifier
    }
  }
`)
